import React, { useState, useEffect } from "react";
import Icon from "@mdi/react";
import { mdiFolderHomeOutline, mdiFileEditOutline, mdiAccountHardHat, mdiPencil, mdiTrashCan } from '@mdi/js';
import { getActivityAll } from "../../interpreter/activity";
import AppDataTable from "./AppDataTable";

export const ActividadeList = ({openModal , refresh}) => {
    const [actividade,setActividade] = useState([]);
    const [loading , setLoading] = useState(true);
    const [error , setError] = useState(null);

    const fechActividade = async() => {
        try {
            const response = await getActivityAll();
            //console.log('456',response);
            const actividadeData = response;
            //console.log('1234',actividadeData);
            if (!actividadeData || !Array.isArray(actividadeData)) {
                throw new Error("Datos de categorías no válidos");
            }

            const formattedData = actividadeData.map(act => ({
                id: act.id , 
                name: act.description
            }))
            //console.log(formattedData);
            setActividade(formattedData);
        } catch (err) {
            setError(err.message);
            console.error("Error en fetchCategories:", err);
        } finally {
            setLoading(false);
        };
    }

    useEffect(()=>{
        fechActividade();
    },[refresh]);

    const columns = [
        { name: "ID", selector: row => row.id, sortable: true, center: true, width: "190px" },
        { name: "Nombre Actividad", selector: row => row.name, sortable: true, center: true, width: "680px" },
        //{ name: "Código", selector: row => row. ?? "N/A", sortable: true, center: true, width: "120px" },
        { name: "Acciones", width: "180px" ,
            cell: (row) => (
                <div className="flex justify-end items-center gap-2 pr-2">
                    <button
                    onClick={() => openModal('delete', row)}
                    className="bg-red-500 hover:bg-red-600 text-white p-2 rounded-md shadow-md transition-all duration-200"
                    title="Eliminar actividad"
                    >
                    <Icon path={mdiTrashCan} size={0.9} />
                    </button>
                    <button
                    onClick={() => openModal('data', row)}
                    className="bg-blue-500 hover:bg-blue-600 text-white p-2 rounded-md shadow-md transition-all duration-200"
                    title="Editar actividad"
                    >
                    <Icon path={mdiPencil} size={0.9} />
                    </button>
                </div>
                ),
            width: "100px",
        },
    ];

    if (loading) return <div className="text-center py-8">Cargando actividades...</div>;
    if (error) return <div className="text-red-500 text-center py-8">{error}</div>;

    return (
        <div>
             {loading ? (<div className="flex justify-center items-center h-40">
            <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid"></div>
          </div>
        ) : (
        <div className="w-full max-w-7xl overflow-x-auto max-h-[500px] overflow-y-auto transition-all duration-300">
          <AppDataTable
                columns={columns}
                data={Array.isArray(actividade) ? actividade : []}
                noDataComponent={<p className="text-gray-500 py-4">No hay actividades disponibles.</p>}
                customStyles={{
                    table: {
                        style: {
                        width: "100%",
                        },
                    },
                    headRow: {
                        style: {
                        backgroundColor: "#f9fafb",
                        borderBottomWidth: "2px",
                        borderBottomColor: "#e5e7eb",
                        },
                    },
                    headCells: {
                        style: {
                        fontSize: "16px",
                        fontWeight: "bold",
                        textTransform: "capitalize",
                        color: "#374151",
                        padding: "16px",
                        },
                    },
                    rows: {
                        style: {
                        backgroundColor: "white",
                        "&:hover": {
                            backgroundColor: "#f0f9ff",
                        },
                        transition: "background-color 0.2s ease",
                        },
                    },
                    cells: {
                        style: {
                        fontSize: "15px",
                        padding: "12px",
                        color: "#4b5563",
                        },
                    },
                }}
            />
        </div>
        )}
        </div>
    );
}